// components/LoginForm.js
"use client";
import React from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import PropTypes from "prop-types";

import InputField from "@/components/InputField";
import Button from "@/components/Button";
import CustomLink from "@/components/CustomLink";
import FormHeader from "@/app/(public)/FormHeader";

const LoginForm = ({ fields, onSubmit, fieldErrors }) => {
  // Generate dynamic validation schema based on fields
  const validationSchema = Yup.object().shape(
    fields.reduce((schema, field) => {
      schema[field.name] = field.validation;
      return schema;
    }, {})
  );

  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors, isSubmitting },
    clearErrors,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

    
  return (
    <div className="grid grid-cols-1 gap-10">
      <FormHeader
        title="Login"
        subtitle="Enter your email and password to login your account"
      />
      <form onSubmit={handleSubmit((data) => onSubmit(data, { reset }))}>
        <div className="grid grid-cols-1 gap-8">
          {fields.map((field, index) => (
            <div key={index} className="grid grid-cols-1 gap-2.5">
              {/* Add key to wrapper */}
              <InputField
              float={"false"}
                control={control}
                label={field.label}
                name={field.name}
                type={field.type}
                register={register}
                errors={errors}
                clearErrors={clearErrors}
                setValue={setValue}
              />
              {!errors[field.name] && fieldErrors[field.name] && (
                <p className="text-red-500 text-sm mt-1">
                  {fieldErrors[field.name]}
                </p>
              )}
            </div>
          ))}
        </div>

        <div className="flex justify-end pt-1.5 pb-8">
          <CustomLink
            href="/forgot-password"
            label="Forgot Password"
            variant="primary"
            className="!text-black text-sm "
            target="_self"
          />
        </div>
        <Button
          variant="solid"
          label="Login"
          size="medium"
          type="submit"
          isLoading={isSubmitting}
          fullWidth={true}
        />
      </form>
    </div>
  );
};

LoginForm.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      validation: PropTypes.object.isRequired,
    })
  ).isRequired,
  onSubmit: PropTypes.func.isRequired,
  fieldErrors: PropTypes.object.isRequired,
};

export default LoginForm;
